import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import auth from './auth';
import locale from './locale';
import registration from './RegistrationViewer';
import adminSettingBooth from './AdminSettingBooth';
import adminSettingSeminarRoom from './AdminSettingSeminarRoom';
import registrationOrganizer from './RegistrationOrganizer';
import eventManagement from './EventManagement';
import adminCompanyManagement from './AdminCompanyManagement';
import organizerManagement from './OrganizerManagement';
import viewerManagement from './ViewerManagement';
import companyManagementOrganizer from './CompanyManagementOrganizer';
import seminarManagementOrganizer from './SeminarManagementOrganizer';
import seminarManagementViewer from './SeminarManagementViewer';
import productManagement from './ProductManagement';
import home from './Home';
import commonOptions from './commonOptions';
import productListOnDisplay from './ProductListOnDisplay';
import organizerList from './OrganizerList';
import organizerPosterList from './OrganizerPosterList';
import seminarRegisteredManagermentViewer from './SeminarRegisteredManagermentViewer';
import surveyManagement from './SurveyManagement';
import registerSeminarManagerment from './RegisterSeminarManagerment';
import favoriteCompanies from './FavoriteCompanies';
import advertisementManagement from './AdvertisementManagement';
import qAListManagerment from './QAListManagerment';
import visitHistoryManagement from './VisitHistoryManagement';
import seminars from './SeminarManagement';
import mail from './Mail';
import livestream from './LiveStreamManagement';
import outerServerMail from './OuterServerMail';
import adminSettingShoppingCart from './AdminSettingShoppingCart';
import settingSellProductOrganizer from './SettingSellProductOrganizer';
import adminOrderProductPaymentManagement from './AdminOrderProductPaymentManagement';
import adminListRegisterLiveStream from './AdminListRegisterLiveStream';
import cartViewer from './CartViewer';
import settingProductCompany from './SettingProductCompany';
import adminSettingCustom from './AdminSettingCustom';
import settingLanguage from './SettingMultiLanguage';

const createRootReducer = (history) => combineReducers({
    router: connectRouter(history),
    locale,
    auth,
    home,
    registration,
    adminSettingBooth,
    adminSettingSeminarRoom,
    registrationOrganizer,
    eventManagement,
    adminCompanyManagement,
    organizerManagement,
    viewerManagement,
    companyManagementOrganizer,
    seminarManagementOrganizer,
    seminarManagementViewer,
    productManagement,
    commonOptions,
    productListOnDisplay,
    organizerList,
    organizerPosterList,
    seminarRegisteredManagermentViewer,
    surveyManagement,
    registerSeminarManagerment,
    favoriteCompanies,
    advertisementManagement,
    qAListManagerment,
    visitHistoryManagement,
    seminars,
    mail,
    livestream,
    outerServerMail,
    adminSettingShoppingCart,
    settingSellProductOrganizer,
    adminOrderProductPaymentManagement,
    adminListRegisterLiveStream,
    cartViewer,
    settingProductCompany,
    adminSettingCustom,
    settingLanguage,
});

export default createRootReducer;
